import Link from 'next/link'
import { memo } from 'react'
import { dateFormat } from 'utils/dates'

import { Button } from '@/components/elements/buttons/button'
import HeaderOverhaul from '@/components/elements/headerOverhaul'
import { TechnologiesAvatarGroup } from '@/components/elements/images/technologiesAvatarGroup'
import RichText from '@/components/elements/texts/richText'
import WrapperMaxWidth from '@/components/elements/wrapperMaxWidth'
import Header from '@/components/shared/header'

import JobOfferGoogleHeader from './jobOfferGoogleHeader'

const JobOfferDetails = ({ jobOffer }) => {
  const {
    name,
    subtitle,
    position,
    publishDate,
    description,
    details,
    technologies
  } = jobOffer
  const header = { title: name, description: subtitle, caption: position }
  const date = dateFormat.Month_D_Yr(new Date(publishDate))

  return (
    <>
      <JobOfferGoogleHeader jobOffer={jobOffer} />
      <Header />
      <WrapperMaxWidth>
        <div className="job-offer-wrapper">
          <HeaderOverhaul
            header={header}
            darkBackground
            titleClassName="job-offer-header"
          />
          <div className="job-offer-container">
            <div className="job-offer-about">
              <div className="job-offer-title">About the role</div>
              <div className="job-offer-date">{date}</div>
            </div>
            <div className="job-offer-description">{description}</div>
            <TechnologiesAvatarGroup
              technologies={technologies.data}
              className="job-offer-technologies"
            />
            <span className="job-offer-details">
              {details.map(detail => (
                <span key={detail.id}>
                  <div className="job-offer-title">{detail.title}</div>
                  <RichText
                    content={detail.description}
                    className="job-offer-description"
                  />
                </span>
              ))}
            </span>
            <Link href={`/contact?subject=${name}`}>
              <Button className="job-offer-button" text="Apply Now" />
            </Link>
          </div>
        </div>
      </WrapperMaxWidth>
    </>
  )
}

export default memo(JobOfferDetails)
